import { downloadBlob } from "@/utils/download-helpers"
import { useMutation } from "@tanstack/react-query"

import { useApiContext } from "@/hooks/api/use-api-context"

import { downloadBeneficiaryReport, type BeneficiaryReportOptions } from "./api"

export function useDownloadBeneficiaryReport(bookIdOverride?: string) {
  const getContext = useApiContext(bookIdOverride)
  return useMutation({
    mutationFn: async (options: BeneficiaryReportOptions) => downloadBeneficiaryReport(await getContext(), options),
    onSuccess: ({ blob, filename }) => downloadBlob(blob, filename),
    meta: { errorToast: { fallback: "Unable to download beneficiary report" } },
  })
}
